import React, {useContext, useRef} from 'react';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import RecommendationSlider from '@personalization/scripts/components/RecommendationSlider.jsx';
import WishlistHeartRecoWrapper from '@wishlist/components/WishlistHeartRecoWrapper.jsx';

export default function RecommendationContainer({ajaxSwiperData, loadingEnabled}) {
    const {lazyloadingPixelDistanceForReco} = useContext(articleOverviewStaticContext);

    const {dataUrl, paramString} = JSON.parse(ajaxSwiperData);
    const loadingEnabledRef = useRef();
    loadingEnabledRef.current = loadingEnabled;
    const MemoizedRecommendationSlider = React.memo(RecommendationSlider);
    return (
        <MemoizedRecommendationSlider
            swiperDataUrl={dataUrl}
            paramStringWithPageViewId={paramString}
            lazyloadingPixelDistance={lazyloadingPixelDistanceForReco}
            loadingEnabledRef={loadingEnabledRef}
            sliderType="reco"
        >
            {loadingEnabled && <WishlistHeartRecoWrapper />}
        </MemoizedRecommendationSlider>
    );
}
